/** ExFMエラークラス */
export class ExFMError extends Error {
  errorMessage: string;
  errorCode: string;

  constructor(message: string, errorMessage: string, errorCode: string) {
    super(message);
    this.errorMessage = errorMessage;
    this.errorCode = errorCode;
  }
}
